import axios from 'axios';

const getApiHost = () => {
  const host = window.location.hostname;

  if (host === 'localhost' || host.endsWith('.local')) {
    return 'https://admin.lecrandusavoir.local';
  }

  return 'https://api-v2.lecrandusavoir.fr';
};

export const apiHost = getApiHost();

export const apiClient = axios.create({
  baseURL: apiHost,
  headers: {
    'Accept': 'application/json',
  },
});
